module.exports = __webpack_public_path__ + "img/ic_20_info.f608d86d.svg";